export class VehOrigen {
    public id: string;
    public codOrigen: string;
    public descOrigen: string;

    public static combinedVehOrigen(vehOrigen: string, vehOrigenDesc: string): string {
          return vehOrigen + ' - ' + vehOrigenDesc;
      }
}
